export default __webpack_public_path__ + "static/media/T.8b4af561.wav";